import { render, staticRenderFns } from "./DispatchNoteInfo.vue?vue&type=template&id=449cc388&scoped=true&"
import script from "./DispatchNoteInfo.vue?vue&type=script&lang=js&"
export * from "./DispatchNoteInfo.vue?vue&type=script&lang=js&"
import style0 from "./DispatchNoteInfo.vue?vue&type=style&index=0&id=449cc388&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449cc388",
  null
  
)

export default component.exports